//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { LibraryTrackingIds } from 'app/components/content/libraryConstants';

(function () {
  angular.module('curalate').component('createNewCollectionButton', {
    template: require('@legacy-components/content/create-new-collection-button.html'),
    bindings: {
      collection: '<',
      isDisabled: '<',
    },
    controller: [
      '$modal',
      '$ngRedux',
      '$q',
      '$scope',
      '$state',
      '$window',
      'rx',
      'CollectionFiltersConverter',
      'CollectionsService',
      'COLLECTION_SETTINGS',
      'CONTENT_LIBRARY_SOURCES_GROUPS',
      'ErrorNotificationService',
      'SEARCH_FILTERS',
      'SearchFilterService',
      'ToastNotificationService',
      'TrackingService',
      function (
        $modal,
        $ngRedux,
        $q,
        $scope,
        $state,
        $window,
        rx,
        CollectionFiltersConverter,
        CollectionsService,
        COLLECTION_SETTINGS,
        CONTENT_LIBRARY_SOURCES_GROUPS,
        ErrorNotificationService,
        SEARCH_FILTERS,
        SearchFilterService,
        ToastNotificationService,
        TrackingService,
      ) {
        const self = this;
        const ngUnsubscribe = new rx.Subject();
        const TRACKING_CATEGORY = TrackingService.CATEGORY_LIBRARY;
        const SKIP_STATE_CHANGE_CHECK_STATES = [
          'library.detail',
          'library.collections',
        ];

        self.dataTrackingId = LibraryTrackingIds.SAVE_AS_COLLECTION;

        let filters = {};
        let collectionConfigFilters;
        let isBeforeUnloadRegistered = false;
        let reloadConfirmMessage;
        let navConfirmMessage;

        const processRightsStatus = function (item) {
          if (item === 'NotSet') {
            return 'None';
          }

          return item;
        };

        const processFiltersForEqualityComparison = function (filterState) {
          const processedFilterState = _(angular.copy(filterState)).mapObject(
            (value) => {
              return _(value).sortBy((element) => {
                return element.value || element;
              });
            },
          );

          if (
            processedFilterState.dateRange &&
            processedFilterState.dateRange.length
          ) {
            const dateRange =
              CollectionFiltersConverter.parseDatePickerFilterObject(
                _(processedFilterState).safeGet('dateRange.0'),
              );
            processedFilterState.dateRange = dateRange;
          }

          if (
            processedFilterState.semanticTags &&
            processedFilterState.semanticTags.length
          ) {
            const semanticTags = _(processedFilterState)
              .chain()
              .safeGet('semanticTags')
              .map((v) => {
                return { tag: v.value || v.tag };
              })
              .sortBy((v) => v.tag);
            processedFilterState.semanticTags = semanticTags;
          }

          // Remove content discovery and google asset feed filters from comparison test since they don't exist in front end filter object
          const keysToRemove = [
            'experimentTags',
            'visualScore',
            'visualSearchDetection',
            'minHeight',
            'maxHeight',
            'minWidth',
            'maxWidth',
            'minAspectRatio',
            'maxAspectRatio',
            'excludeMatchedMisItemForInstagramPost',
            'excludeOriginalRepostedInstagramItem',
            'excludeMatchedInstagramItemForInstagramStory',
          ];

          return _(processedFilterState)
            .chain()
            .omit(keysToRemove)
            .extend({
              socialFilters: _(processedFilterState.socialFilters).map(
                (socialFilter) => {
                  return {
                    type: socialFilter.type,
                    value: socialFilter.value,
                    aliasKey: socialFilter.aliasKey,
                  };
                },
              ),
            })
            .value();
        };

        const extractSourcesFromFilters = function () {
          return {
            allMedia: filters.sourcesGroups?.includes(
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_MEDIA,
            ),
            allInstagram: filters.sourcesGroups?.includes(
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_INSTAGRAM,
            ),
            allPinterest: filters.sourcesGroups?.includes(
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_PINTEREST,
            ),
            allCuralateUsers: filters.sourcesGroups?.includes(
              CONTENT_LIBRARY_SOURCES_GROUPS.TEAM_MEDIA,
            ),
            allInstagramUsers: filters.sourcesGroups?.includes(
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TRACKED_USERS,
            ),
            allInstagramHashtags: filters.sourcesGroups?.includes(
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TRACKED_HASHTAGS,
            ),
            allBrandInstagram: filters.sourcesGroups?.includes(
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_BRAND_POSTS,
            ),
            allDropbox: filters.sourcesGroups?.includes(
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_DROPBOX,
            ),
            allTikTok: filters.sourcesGroups?.includes(
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TIKTOK,
            ),
            allYouTube: filters.sourcesGroups?.includes(
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_YOUTUBE,
            ),
            brandFeedPost:
              filters.brandFeedPost && filters.brandFeedPost.length > 0,
            brandStoryPost:
              filters.brandStoryPost && filters.brandStoryPost.length > 0,
            curalateUsers: filters.curalateUserIds || [],
            galleryUploaders: filters.galleryUploaders || [],
            instagramUsers: filters.trackedUserIds || [],
            instagramBusinessUsers: filters.trackedBusinessUserIds || [],
            instagramHashtags: filters.trackedHashtags || [],
            instagramMentions: filters.accountMentionIds || [],
            pinterestUsers: filters.pinterestUserIds || [],
          };
        };

        const processFiltersToCollectionRules = function (name) {
          const processedFilters = {};

          processedFilters[COLLECTION_SETTINGS.KEYS.NAME] = name;

          // Everything in the DTO which is of type CollectionFilterDto
          processedFilters[COLLECTION_SETTINGS.KEYS.FILTERS] = _({
            orientations: filters.orientation,
            labels: filters.labels,
            rights: _(filters.rightsStatuses).map((item) => {
              return processRightsStatus(item);
            }),
            mediaTypes: filters.mediaItemTypes,
            productTags: filters.hasProducts,
            instagramUsers: _.chain(filters.socialFilters)
              .filter((socialFilter) => {
                return socialFilter.type === 'username';
              })
              .pluck('value')
              .value(),
            instagramHashtags: _.chain(filters.socialFilters)
              .filter((socialFilter) => {
                return socialFilter.type === 'hashtag';
              })
              .pluck('value')
              .value(),
          }).mapObject((valuesList) => {
            return {
              options: valuesList,
            };
          });

          if (filters.experimentTags) {
            processedFilters[COLLECTION_SETTINGS.KEYS.FILTERS].experimentTags =
              filters.experimentTags;
          }

          if (filters.semanticTags) {
            processedFilters[COLLECTION_SETTINGS.KEYS.FILTERS].semanticTags = {
              tags: _(filters.semanticTags).map((t) => {
                return {
                  tag: t.value || t.tag,
                };
              }),
            };
          }

          processedFilters[COLLECTION_SETTINGS.KEYS.FILTERS].dateRange =
            CollectionFiltersConverter.parseDatePickerFilterObject(
              _(filters).safeGet('dateRange.0'),
            );
          processedFilters[COLLECTION_SETTINGS.KEYS.FILTERS].spam =
            _(filters).safeGet('spamFiltering.0') === 'true';

          if (
            !_(filters.distribution).isEmpty() &&
            !_(filters.isDistributed).isEmpty()
          ) {
            processedFilters[COLLECTION_SETTINGS.KEYS.FILTERS].distribution = {
              options: filters.distribution,
              isDistributed: filters.isDistributed[0] === 'true',
            };
          }

          processedFilters[
            COLLECTION_SETTINGS.KEYS.FILTERS
          ].excludedContentSources = filters.excludedContentSources;

          processedFilters[COLLECTION_SETTINGS.KEYS.SOURCES] =
            extractSourcesFromFilters();

          const sortKey = _(filters).safeGet('orderBy.0');
          if (sortKey) {
            processedFilters[COLLECTION_SETTINGS.KEYS.SORT] = {
              key: sortKey,
              ascending: false, // This is not currently configurable in the frontend
            };
          }

          return processedFilters;
        };

        self.registerUnsavedChangesPrompt = (hasUnsavedChanges) => {
          if (hasUnsavedChanges && !isBeforeUnloadRegistered) {
            $($window).on('beforeunload', () => reloadConfirmMessage);
            isBeforeUnloadRegistered = true;
          } else if (!hasUnsavedChanges && isBeforeUnloadRegistered) {
            self.unregisterUnsavedChangesPrompt();
          }
        };

        self.unregisterUnsavedChangesPrompt = () => {
          $($window).off('beforeunload');
          isBeforeUnloadRegistered = false;
        };

        self.collectionHasUnsavedChanges = function () {
          const currentFilters = processFiltersForEqualityComparison(filters);
          const collectionFilters = processFiltersForEqualityComparison(
            collectionConfigFilters,
          );

          const hasUnsavedChanges =
            self.collection &&
            !angular.equals(collectionFilters, currentFilters);
          self.registerUnsavedChangesPrompt(hasUnsavedChanges);

          return hasUnsavedChanges;
        };

        const trackCreateAction = function (action, collectionSettings) {
          const formattedSources = [];
          _(collectionSettings.sources).each((value, key) => {
            if (value === true) {
              formattedSources.push(key);
            } else if (!_(value).isEmpty()) {
              formattedSources.push(value.join(','));
            }
          });

          const formattedFilters = [];
          _(collectionSettings.filters).each((value, key) => {
            if (value && !_(value.options).isEmpty()) {
              formattedFilters.push(`${key} ${value.options.join(',')}`);
            } else if (key === 'spam') {
              // This should always be a boolean, but opted to be explicit here since we're dealing with all sorts of types.
              if (value === true) {
                formattedFilters.push('spamFiltering enabled');
              }
            }
          });

          const eventLabel = `Filters: [${formattedFilters.join('; ')}] Sources: [${formattedSources.join('; ')}]`;
          TrackingService.recordEvent(TRACKING_CATEGORY, action, eventLabel);
        };

        const createOrSaveCollectionImpl = function (collectionName) {
          const collectionSettings =
            processFiltersToCollectionRules(collectionName);
          self.outstandingAsyncAction = 'saving-collection';

          if (self.collection) {
            CollectionsService.updateCollection(
              self.collection.id,
              collectionSettings,
            )
              .then(() => {
                ToastNotificationService.success({
                  title: 'Collection configuration saved',
                });
              })
              .catch((error) => {
                ErrorNotificationService.showDefaultErrorDialog(error);
              })
              .finally(() => {
                self.outstandingAsyncAction = null;
                trackCreateAction(
                  TrackingService.ACTION_COLLECTIONS_UPDATE,
                  collectionSettings,
                );
              });
          } else {
            CollectionsService.createCollectionWithoutNotification(
              collectionSettings,
            )
              .takeUntil(ngUnsubscribe)
              .subscribe(
                (response) => {
                  $state.go('library.collections.content', {
                    collectionId: response.id,
                  });
                  trackCreateAction(
                    TrackingService.ACTION_COLLECTIONS_SAVE_AS,
                    collectionSettings,
                  );
                },
                (error) => {
                  ErrorNotificationService.showDefaultErrorDialog(error);
                  self.outstandingAsyncAction = null;
                },
              );
          }
        };

        self.createOrSaveCollection = function () {
          let namePromise;

          if (self.collection) {
            namePromise = $q.when(self.collection.name);
          } else {
            const modal = $modal.open({
              template:
                '<collection-naming-modal modal-instance="modalInstance" click-origin="SaveAsButton"></collection-naming-modal>',
              windowClass: 'pure-bs3 modal-collection-name',
              controller: [
                '$modalInstance',
                '$scope',
                function ($modalInstance, $modalScope) {
                  $modalScope.modalInstance = $modalInstance;
                },
              ],
            });

            namePromise = modal.result;
          }

          namePromise.then((collectionName) => {
            createOrSaveCollectionImpl(collectionName);
          });
        };

        self.shouldDisableSaveCollection = function () {
          return (
            self.isDisabled ||
            self.outstandingAsyncAction ||
            (self.collection && !self.collectionHasUnsavedChanges()) ||
            !_(self.bulkUiaSelectedItems).isEmpty()
          );
        };

        self.$onInit = function () {
          self.outstandingAsyncAction = 'loading-filters';

          const filtersObservable =
            SearchFilterService.getObservableForFilterSet(
              SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS,
            );
          const sourcesObservable =
            SearchFilterService.getObservableForFilterSet(
              SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS,
            );
          const sortObservable = SearchFilterService.getObservableForFilterSet(
            SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS_SORT,
          );

          const searchFilterObservable = rx.Observable.merge(
            filtersObservable,
            sourcesObservable,
            sortObservable,
          );

          // Because SearchFilterService implements all of its filter streams as a BehaviorSubject, subscribing
          // to a merged stream (like we do above) may only return an update for the last filter set that emitted
          // an update, causing us to miss updates from other filter sets. The fix here is to directly retrieve the
          // state of SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS instead of waiting for it to come through
          // the Observable. Tracked by: https://curalate.atlassian.net/browse/DEV-31256
          const sourcesInitialState = SearchFilterService.getRegisteredSet(
            SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS,
          );
          if (sourcesInitialState) {
            filters = _(filters).extend(sourcesInitialState.params);
          }

          searchFilterObservable
            .takeUntil(ngUnsubscribe)
            .subscribe((newFilters) => {
              filters = _(filters).extend(newFilters.setObject);
            });

          searchFilterObservable
            .takeUntil(ngUnsubscribe)
            .take(1)
            .subscribe(() => {
              self.outstandingAsyncAction = null;
            });

          const mapStateToThis = (state) => {
            return {
              bulkUiaSelectedItems: state.bulkActions.selectedItems,
            };
          };

          self.reduxUnsubscribe = $ngRedux.connect(mapStateToThis, null)(self);

          $scope.$on('$stateChangeStart', (event, toState) => {
            let isDeleted = false;
            if (self.collection) {
              isDeleted = !CollectionsService.collectionExists(
                self.collection.id,
              );
            }
            // filters are cached when navigating to content detail pages.
            if (
              !isDeleted &&
              toState &&
              !_(SKIP_STATE_CHANGE_CHECK_STATES).contains(toState.name)
            ) {
              const hasUnsavedChanges = self.collectionHasUnsavedChanges();
              if (hasUnsavedChanges && !$window.confirm(navConfirmMessage)) {
                event.preventDefault();
              }
            }
          });
        };

        self.$onChanges = function (changesObj) {
          if (changesObj.collection) {
            const collection = changesObj.collection.currentValue;
            if (collection) {
              const filtersFromCollection = angular.copy(
                CollectionFiltersConverter.collectionToFilters(collection),
              );
              const orderByKey = filtersFromCollection.orderByKey;
              collectionConfigFilters = _.extend(
                // fill in the default orderBy value to compare to the current filters
                orderByKey
                  ? { orderBy: [orderByKey] }
                  : { orderBy: [COLLECTION_SETTINGS.SORT_KEYS.TIME] },
                filtersFromCollection.sourcesFilters,
                filtersFromCollection.filtersFilters,
              );
              reloadConfirmMessage = `Changes made to ${self.collection.name}'s sources and filters will not be saved.`;
              navConfirmMessage =
                `${reloadConfirmMessage}\n\nClick "Cancel" and save your updates, ` +
                'or "Ok" to discard changes and leave the Collection.';
            } else {
              collectionConfigFilters = undefined;
            }
          }
        };

        self.$onDestroy = function () {
          ngUnsubscribe.next();
          if (self.collection && self.collectionHasUnsavedChanges()) {
            TrackingService.recordEvent(
              TRACKING_CATEGORY,
              TrackingService.ACTION_COLLECTIONS_ABANDON_CHANGES,
            );
          }
          self.unregisterUnsavedChangesPrompt();
          self.reduxUnsubscribe();
        };
      },
    ],
  });
})();
